<uikit-search-select
  (selection)="addItemListItem($event)"
  [options]="itemMenuOptions()"
  [alwaysFirstValue]="itemConfig.alwaysFirstValue"
  [showSearch]="true"
  [displayProperty]="itemConfig.displayProperty"
  [sorted]="itemConfig.sorted"
  [selected]="appliedSelection.item"
  [placeholderText]="itemConfig.placeholderText"
  [dropdownWidth]="itemConfig.dropdownWidth"
  [closeOnClick]="closeSelectOnClick"
  />
@if (!!appliedSelection.item) {
  <div class="item-and-status-separator"></div>
}
@if (!!appliedSelection.item) {
  <uikit-search-select
    (selection)="changeItemStatus($event)"
    [options]="statusMenuOptions()"
    [alwaysFirstValue]="statusConfig.alwaysFirstValue"
    [displayProperty]="statusConfig.displayProperty"
    [sorted]="statusConfig.sorted"
    [selected]="appliedSelection?.status"
    [placeholderText]="statusConfig.placeholderText"
    [showSearch]="false"
    [closeOnClick]="closeSelectOnClick"
    />
}
@if (!!appliedSelection.item && appliedSelection.item.editions?.length > 0) {
  <div
    class="item-and-status-separator"
  ></div>
}
@if (!!appliedSelection.item && appliedSelection.item.editions?.length > 0) {
  <uikit-search-select
    (selection)="changeItemEdition($event)"
    [options]="editionMenuOptions()"
    [alwaysFirstValue]="editionConfig.alwaysFirstValue"
    [displayProperty]="editionConfig.displayProperty"
    [sorted]="editionConfig.sorted"
    [selected]="appliedSelection?.edition"
    [placeholderText]="editionConfig.placeholderText"
    [showSearch]="false"
    [closeOnClick]="closeSelectOnClick"
    />
}
